import ArtraApp from './assets/ts/artra-app';
import { HeaderController } from './assets/ts/controllers/header.controller';
import { LanguageMenuHandler } from './assets/ts/controllers/language-menu.controller';
import { FooterController } from './assets/ts/controllers/footer.controller';
import { ProductsController } from './assets/ts/controllers/products.controller';
import { ConsentCookies } from './assets/ts/cookieconsent';

/**
 * JS executed on runtime
 * TODO: rewrite
 */
import './assets/js/mobile-nav';

const artra = new ArtraApp(window.appConfig, window.env);
window['artra'] = artra;

(() => {
  new ConsentCookies();
  new HeaderController(true);
  // WTF: Product controller is required for language dropdown menu ôÔ
  new ProductsController(artra);
  new LanguageMenuHandler();
  new FooterController();
})();
